module.exports = __webpack_public_path__ + "static/media/videothumb.70bd307f.jpg";